import TranslationNS from '@/utils/Constants/TranslationNS'

const LB = TranslationNS.LEADERBOARD

/**
 * Page tour of « Vue TV » (`leaderboard/tv-config`): the ranking shown on a screen. No Save on this
 * page (every change applies at once), so the last step is the « Open TV view » slot.
 */
export const TV_VIEW_TOUR = {
    id: 'tv-view',
    version: 1,
    paths: ['leaderboard/tv-config'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'The ranking on a screen',
            description: 'Set up the ranking shown on a TV during the event. Every change applies at once.',
        },
        {
            key: 'content',
            target: '[data-tour="sec-content"]',
            placement: 'bottom',
            title: 'What the screen shows',
            description:
                'Choose what appears for each participant: overall rank, points, score ranks, the scores themselves.',
        },
        {
            key: 'divisions',
            target: '[data-tour="sec-divisions"]',
            placement: 'bottom',
            title: 'Which divisions',
            description: 'All divisions, or only the ones you tick.',
        },
        {
            key: 'scores',
            target: '[data-tour="sec-scores"]',
            placement: 'bottom',
            title: 'Which scores',
            description: 'All scores, or only the ones you tick: each one becomes a column.',
        },
        {
            key: 'display',
            target: '[data-tour="sec-display"]',
            placement: 'top',
            title: 'Pages and rotation',
            description:
                'How many participants per page, and every how many seconds the screen moves to the next page.',
        },
        {
            key: 'open',
            target: '[data-tour="page-save"]',
            placement: 'bottomRight',
            placementNarrow: 'bottomLeft',
            title: 'Show it on the TV',
            description: 'Open the TV view on the screen’s computer, or copy its link to send it.',
            entries: [
                { label: 'Copy link', ns: LB, text: 'the address to open on the screen.' },
                { label: 'Open TV view', ns: LB, text: 'see it right now in a new tab.' },
            ],
        },
    ],
}

export default TV_VIEW_TOUR
